import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";

export default {
  state: () => ({
    selectedReportUrl: null,
    selectedReportId: null,
  }),

  mutations: {
    setSelectedReportUrl(state, selectedReportUrl) {
      Vue.set(state, "selectedReportUrl", selectedReportUrl);
    },
    setSelectedReportId(state, selectedReportId) {
      Vue.set(state, "selectedReportId", selectedReportId);
    },
    setDefaultReportModule(state, selectedReportId) {
      Vue.set(state, "selectedReportUrl", null);
      Vue.set(state, "selectedReportId", null);
    },
  },

  actions: {
    //TODO: load, update, create
    loadReport: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/metabase/dashboard/" + request.id, {}).then((response) => {
        context.commit("setSelectedReportUrl", response.data);
      });
    },
    loadTrainKmOccupancyReport: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/reports/train-km-occupancy-report", request).then((response) => {
        return response.data;
      });
    },
    // Fiyat Karşılaştırma Raporu
    searchPriceComparisonTrains: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/reports/price-comparison/trains", request).then((response) => {
        return response.data;
      });
    },
    loadPriceComparisonDefinitions: (context, scheduleId) => {
      return axios.get(context.getters.getMcServiceUrl + "/reports/price-comparison/definitions/" + scheduleId).then((response) => {
        return response.data;
      });
    },
    loadPriceComparisonBookingClasses: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/reports/price-comparison/booking-classes").then((response) => {
        return response.data;
      });
    },
    loadPriceComparisonStations: (context, request) => {
      return axios
        .get(context.getters.getMcServiceUrl + "/reports/price-comparison/stations/" + request.scheduleId, {
          params: { anchorDate: request.anchorDate },
        })
        .then((response) => {
          return response.data;
        });
    },
    loadPriceComparisonReport: (context, request) => {
      return axios.post(context.getters.getMcServiceUrl + "/reports/price-comparison", request).then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getSelectedReportUrl: (state) => {
      return state.selectedReportUrl;
    },
    getSelectedReportId: (state) => {
      return state.selectedReportId;
    },
  },
};
